import { render, staticRenderFns } from "./CardInformacoesCliente.vue?vue&type=template&id=34a1e5c2&scoped=true&"
import script from "./CardInformacoesCliente.vue?vue&type=script&lang=js&"
export * from "./CardInformacoesCliente.vue?vue&type=script&lang=js&"
import style0 from "./CardInformacoesCliente.vue?vue&type=style&index=0&id=34a1e5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a1e5c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardTitle,VRow,VSkeletonLoader})
